import React from 'react';
import Timeline from '../timeline/Timeline';

const Resume = () => {
    return (
        <div className="main-body">
            <h3>Resume</h3>
            <hr></hr>
            <h4>More of my credentials.</h4>
            <div>
                <Timeline/>
            </div>
        </div>
    )
}

export default Resume;